import { Component, OnInit, OnDestroy, Output, EventEmitter, Input, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ToastService } from 'src/app/_metronic/shared/components/toast/toast.service';

@Component({
  selector: 'app-check-email',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './check-email.component.html',
  styleUrls: ['./check-email.component.scss']
})
export class CheckEmailComponent implements OnInit, OnDestroy {
  @Input() email: string = '';
  @Output() backClick = new EventEmitter<void>();
  @Output() resendClick = new EventEmitter<void>();

  countdown = 0;
  countdownInterval: any;
  canResend = true;

  constructor(
    private translate: TranslateService,
    private toastService: ToastService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    // Countdown will start only when user clicks resend
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  startCountdown(): void {
    this.countdown = 60;
    this.canResend = false;

    this.countdownInterval = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        this.clearCountdown();
        this.canResend = true;
      }
      this.cdr.detectChanges(); // Force update view
    }, 1000);
  }

  clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  getCountdownDisplay(): string {
    const minutes = Math.floor(this.countdown / 60);
    const seconds = this.countdown % 60;
    return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }

  onResendClick(): void {
    if (!this.canResend) return;

    // Show success toast
    this.toastService.success('FORGOT_PASSWORD.RESEND_SUCCESS');

    // Emit resend event
    this.resendClick.emit();

    // Restart countdown
    this.startCountdown();
  }

  onBackClick(): void {
    this.backClick.emit();
  }
}

